export enum PayablesLineType {
    TRANSPORT = 'TRANSPORT',
    WAITING = 'WAITING',
    LABOR = 'LABOR',
    DAMAGED_GOODS = 'DAMAGED_GOODS',
    MULTIPLE_DROPOFF = 'MULTIPLE_DROPOFF',
    MISCELLANEOUS = 'MISCELLANEOUS'
}
